export const labelColumnData: { label: string; value: string | number }[] = [
  { label: "GVF at Intake", value: "87.5 %" },
  { label: "Required System TDH", value: "3384.541 ft" },
  { label: "Main Pump model", value: "400AAI300H 445 stg" },
  { label: "Motor specification", value: "DH_375S - 19/449/33" },
  { label: "Main Pump Model", value: "400AAI300H 445 stg" },
  { label: "Motor Specification", value: "DH_375S - 19/449/33" },
  { label: "Protector Shaft Load", value: "79 %" },
  { label: "Cable details/Motor NP ratio", value: "CABLE #2 ROUND 204C 5KV" },
  { label: "Cable Details / Motor NP Ratio", value: "CABLE #2 ROUND 204C 5KV" },
  { label: "GVF at Main Pump", value: "7.8 %" },
  { label: "System Lift TDH", value: "4.9 ft" },
  { label: "Pump Shaft Load", value: "1129673 %" },
  { label: "Motor Load", value: "49.24 %" },
  { label: "Protector Bearing Load", value: "49.24 %" },
  { label: "VSD Load information", value: "166 KVA / 200 A" },
  { label: "VSD Load Information", value: "166 KVA / 200 A" },
];

export const equipmentOptions = [
  { 'id': '0', 'name': 'Active' },
  { 'id': '1', 'name': 'International' },
  { 'id': '2', 'name': 'Permian' },
  { 'id': '3', 'name': 'Active + Obsolete' }
];
